import React from "react";
import {COLORWAY_CODES} from "../../../../../core/constants/color";
import ColorOption from "./ColorOption";

const ColorwayAccordion = ({
                             colorway,
                             isExpanded,
                             handleToggle,
                             keyColorItem,
                             secondaryColorItem,
                             thirdColorItem,
                             stepObject,
                             navigationDataObject,
                             slideToSubHandler
                           }) => {
  const isSingleColor = colorway.colorwayCode === COLORWAY_CODES.SINGLE;
  const isRearSeatHighlight = colorway.colorwayCode === COLORWAY_CODES.REAR_HIGHLIGHT;


  return (
    <div className="accordion-wrapper" data-expand={isExpanded}>
      <div
        className="accordion-header"
        onClick={() => handleToggle(colorway.colorwayCode)}
      >
        <h2>{colorway.title}</h2>
      </div>

      <div className="accordion-content">
        <ColorOption
          code={"INT_KEY"}
          colorItemObject={keyColorItem}
          navigationDataObject={navigationDataObject}
          stepObject={stepObject}
          slideToSubHandler={slideToSubHandler}
          targetDepth="3"
          visible={!!keyColorItem}
        />

        {/* Secondary Color */}
        <ColorOption
          code={"INT_SECONDARY"}
          colorItemObject={secondaryColorItem}
          navigationDataObject={navigationDataObject}
          stepObject={stepObject}
          slideToSubHandler={slideToSubHandler}
          targetDepth="3"
          visible={!isSingleColor && !!secondaryColorItem}
        />

        {/* Third Color */}
        <ColorOption
          code={"INT_THIRD"}
          colorItemObject={thirdColorItem}
          navigationDataObject={navigationDataObject}
          stepObject={stepObject}
          slideToSubHandler={slideToSubHandler}
          targetDepth="3"
          visible={isRearSeatHighlight && !!thirdColorItem}
        />
      </div>
    </div>
  );
};

export default ColorwayAccordion;
